const Link = {
    baseStyle: {
        px: {
            base: 3,
            lg: 4,
        },
        py: {
            base: 2,
            lg: 3,
        },
        borderRadius: "md",
        color: "white",
        fontWeight: "normal",
        fontSize: {
            base: 16,
            lg: 24,
        },
    },
};

export default Link;
